import { InjectionToken } from '@angular/core';
import { Request } from 'express'; // Or your server framework's Request type

export const REQUEST = new InjectionToken<Request>('REQUEST');
